import React from 'react';
import css from './FieldLabel.module.css';

const SupportingText = ({ text, id }) => (
  <div id={`SupportingText_${id}`} className={css.supportingText}>
    {text}
  </div>
);

export const FieldLabel = ({ label, id, supportingText }) => {
  const classWithSupportingText = supportingText ? css.withSupportingText : '';
  return (
    <>
      {label ? (
        <label className={classWithSupportingText} htmlFor={id}>
          {label}
        </label>
      ) : null}
      {supportingText ? <SupportingText text={supportingText} id={id} /> : null}
    </>
  );
};
